import { memo } from 'react'
import { Divider, Grid, Stack, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { IProductWarrantyClaim, ProductWarrantyClaimProductIs, ProductWarrantyClaimReason, YesNoOptions } from '@cbgms/api'
import { RadioGroup, RadioOption, TextField } from '@carsys/form'
import { useStyles } from '../styles/form.style'
import AttachmentFields from './AttachmentFields'
import MultilineTextFieldWithPrint from '@cbgms/components/form/MultilineTextFieldWithPrint'
import { useFormikContext } from 'formik'

const _WholesalerFields = () => {
  const { t } = useTranslation()
  const classes = useStyles()
  const { values: formValues } = useFormikContext<IProductWarrantyClaim>()

  return (
    <Grid item direction='column'>
      <Grid item sx={{ mt: 1, mb: 3 }}>
        <Divider className={classes.widthPercentage} />
      </Grid>

      <Grid item sx={{ mt: 1 }}>
        <Typography fontWeight='500'>{t('productWarrantyClaim.internal_use_helper_text')}</Typography>
      </Grid>

      <Grid xs item sx={{ mt: 2 }}>
        <Stack direction='row' spacing={1}>
          <RadioGroup className={classes.radioGroupField} label={t('productWarrantyClaim.assigned')} name='Assigned' row>
            <RadioOption label={t('global.yes')} value={YesNoOptions.YES} />
            <RadioOption label={t('global.no')} value={YesNoOptions.NO} />
          </RadioGroup>
        </Stack>
      </Grid>

      <Grid xs item sx={{ mt: 2 }}>
        <Stack direction='row' spacing={1}>
          <RadioGroup className={classes.radioGroupField} label={t('productWarrantyClaim.reason')} name='Reason' row>
            <RadioOption label={t('Enum.ProductWarrantyClaimReason_technical')} value={ProductWarrantyClaimReason.Technical} />
            <RadioOption label={t('Enum.ProductWarrantyClaimReason_commercial')} value={ProductWarrantyClaimReason.Commercial} />
          </RadioGroup>
        </Stack>
      </Grid>

      <Grid xs item sx={{ mt: 2 }}>
        <MultilineTextFieldWithPrint
          className={classes.inputTextAreaField}
          label={t('productWarrantyClaim.remarks')}
          minRows={4}
          name='Remark'
          value={formValues?.Remark || ''}
        />
      </Grid>

      <Grid xs item sx={{ mt: 2 }}>
        <Stack direction='row' spacing={1}>
          <TextField required className={classes.inputTextField} label={t('productWarrantyClaim.supplier')} name='SupplierName' />
        </Stack>
      </Grid>

      <Grid xs item sx={{ mt: 2 }}>
        <Stack direction='row' spacing={1}>
          <RadioGroup className={classes.radioGroupField} label={t('productWarrantyClaim.productIs')} name='ProductIs' row>
            <RadioOption label={t('Enum.ProductWarrantyClaimProductIs_credited')} value={ProductWarrantyClaimProductIs.Credited} />
            <RadioOption label={t('Enum.ProductWarrantyClaimProductIs_redelivered')} value={ProductWarrantyClaimProductIs.Redelivered} />
          </RadioGroup>
        </Stack>
      </Grid>

      <Grid xs item sx={{ mt: 2 }}>
        <Stack direction='row' spacing={1}>
          <TextField className={classes.inputTextField} label={t('productWarrantyClaim.onPackingSlip')} name='PackingSlip' />
        </Stack>
      </Grid>

      <Grid xs item>
        <AttachmentFields />
      </Grid>
    </Grid>
  )
}

const WholesalerFields = memo(_WholesalerFields)
export default WholesalerFields
